import React from "react";
import logo from "../assets/images/png/desktop.png";

const SplashScreen = () => (
  <div className="splash-screen">
    <img src={logo} width={80} alt="Logo" className="splash-logo" />
    <div className="splash-loader"></div>
  </div>
);

export default SplashScreen;
